.bottomBar {
  align-items: center;
  background: #f7f3f4;
  border-top: 1px solid #eeeeee;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 16px;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom, 0px));
  width: 100%;
  z-index: 10;
}

.subscribe {
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--brand-button-color);
  border-radius: 9999px;
  /* border-box so the 1px stroke sits inside the 48px pill, as in Figma. */
  box-sizing: border-box;
  color: var(--brand-button-color);
  cursor: pointer;
  display: flex;
  font-weight: 600;
  height: 48px;
  justify-content: center;
  line-height: 24px;
  /* Desktop guard: the Figma frame is a 375px mobile artboard. */
  max-width: 480px;
  padding: 0 24px;
  width: 100%;
}

.subscribe:hover {
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.12);
}

.login {
  align-items: center;
  background: transparent;
  border: 0;
  color: var(--brand-button-dark-color, var(--brand-button-color));
  cursor: pointer;
  display: inline-flex;
  font-weight: 600;
  gap: 4px;
  /* 24px line box holds the row at its pre-icon height (Figma
     button-text-md); vertical padding would push it past 24px. */
  line-height: 24px;
  padding: 0 8px;
}

.login:hover {
  text-decoration: underline;
}

.loginIcon {
  height: 20px;
  width: 20px;
}
